import React from "react";
import styles from "./Modal.module.css";
import { RiCloseLine } from "react-icons/ri";
import Button from "./Button";

const Modal = ({ setIsOpen, onDelete, loading, data, heading }) => {
  return (
    <>
      <div className={styles.darkBG} onClick={() => setIsOpen(false)} />
      <div className={styles.centered}>
        <div className={styles.modal}>
          {heading && (
            <div className={styles.modalHeader}>
              <h5 className={styles.heading}>{heading}</h5>
            </div>
          )}
          <button className={styles.closeBtn} onClick={() => setIsOpen(false)}>
            <RiCloseLine style={{ marginBottom: "-3px" }} />
          </button>
          {data}
          {/*   <div className={styles.modalContent}>
            Are you sure you want to delete the item?
          </div>
          <div className={styles.modalActions}>
            <div className={styles.actionsContainer}>
              <Button title={"Delete"} onClick={onDelete} loading={loading} />
              <Button title={"Cancel"} onClick={() => setIsOpen(false)} />
              //  <button
              //   className={styles.deleteBtn}
              //   onClick={() => setIsOpen(false)}
              // >
              //   Delete
              // </button>
              // <button
              //   className={styles.cancelBtn}
              //   onClick={() => setIsOpen(false)}
              // >
              //   Cancel
              // </button> 
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Modal;
